import React from 'react';
import cx from 'classnames';
import { ReactComponent as Delete } from '../../../assets/img/icons/common/Delete.svg';
import './SwitchableImage.scss';

export const SwitchableImage = ({
  imageClassName,
  images = [],
  currentImage = 0,
  onChangeCurrent,
  onImageClick,
  onDelete,
}) => {
  return (
    <div className="table-cell__switchable-image">
      {images.length > 1 && (
        <div className="images-switcher">
          {images.map((_, imageIndex) => (
            <span
              key={imageIndex}
              className={cx('images-switcher__item', { active: imageIndex === currentImage })}
              onClick={() => onChangeCurrent(imageIndex)}
            >
              {imageIndex + 1}
            </span>
          ))}
        </div>
      )}
      <button className="images-delete-btn" onClick={onDelete}>
        <Delete />
      </button>
      <img className={imageClassName} src={images[currentImage]} onClick={onImageClick} />
    </div>
  );
};
